import React from "react";

import pdf from "@react-pdf/renderer";

const { View, StyleSheet } = pdf;

const styles = StyleSheet.create({
  root: {
    width: "100%",
    display: "flex",
  },
  row: {
    flexDirection: "row",
  },
  column: {
    flexDirection: "column",
  },
});

const justifyContentStyles = StyleSheet.create({
  center: {
    justifyContent: "center",
  },
  end: {
    justifyContent: "flex-end",
  },
  start: {
    justifyContent: "flex-start",
  },
  spaceBetween: {
    justifyContent: "space-between",
  },
});

const alignItemsStyle = StyleSheet.create({
  center: {
    alignItems: "center",
  },
  end: {
    alignItems: "flex-end",
  },
  start: {
    alignItems: "flex-start",
  },
});

type Props = {
  flexDirection?: "row" | "column";
  alignItems?: "end" | "start" | "center";
  justifyContent?: "end" | "start" | "center" | "spaceBetween";
};
const Flex: React.FC<Props> = ({
  flexDirection = "row",
  alignItems = "start",
  justifyContent = "start",
  children,
}) => {
  return (
    <View
      style={[
        styles.root,
        styles[flexDirection],
        justifyContentStyles[justifyContent],
        alignItemsStyle[alignItems],
      ]}
    >
      {children}
    </View>
  );
};

export default Flex;
